import React from 'react';
import './NextButton.scss';
import { ReactComponent as RightArrow } from '../../image/right-arrow.svg';

//todo Figure out how to add descriptions to props in JSDOC

/**Styled progressive "next" button.
 * @param {{
 *  children: any,
 *  label: string,
 *  action: Function,
 *  disabled: boolean?
 * }} props
 */
function NextButton(props) {
    let { action, disabled } = props;
    if (typeof disabled === 'undefined') disabled = false;

    return (
        <button
            type="submit"
            onClick={action}
            className="next-button"
            disabled={disabled}
        >
            <span>{props.children}</span>
            <RightArrow />
        </button>
    );
}

export default NextButton;
